// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"410":"27b366ef","725":"4b47168d"}[chunkId] + ".css";
};